import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import Radio from 'components/Form/RadioButton'
import Select from 'components/Select/index'
import { FormItem, RadioGroup } from 'components/UIComponents/FormStyles'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import FileReader from 'components/Uploader/FileReader'
import CrossFillIcon from 'components/icons/CrossFillIcon'
import DeleteIcon from 'components/icons/DeleteIcon'
import DownLoadIcon from 'components/icons/DownLoadIcon'
import PlusWhiteIcon from 'components/icons/PlusBlueIcon'
import UploadIcon from 'components/icons/UploadIcon'
import UploadResultIcon from 'components/icons/UploadResultIcon'
import WarningIcon from 'components/icons/WarningIcon'
import { Label } from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/style'
import {
  ButtonDiv,
  CandiadateFlex,
  CandidateInfo,
  Divider,
  DocFlex,
  ErrorWrap,
  FileInfoDiv,
  FileNameDiv,
  FileTextSpan,
  FooterFlex,
  HeadTextWrap,
  IconWrapper,
  ListItem,
  RemarksDiv,
  ResultDiv,
  ResultIconDiv,
  ScoreFlex,
  SpinStyle,
  StyledUpload,
  SubText,
  TemolateDiv,
  UploadFileDiv,
  UploadFlex,
  UploadIconDiv,
  UploadMsgFlex,
  Wrap,
  Wrapper,
} from 'modules/Drives/DownloadAndUpload/UploadResultDrawer/style'
import {
  // RemarksDiv,
  FlexWrapper,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/style'
import { uploadFile } from 'modules/ManageProfile/actions'
import {
  getNotificationCatalogues,
  sendNotificationBulkEmail,
} from 'modules/Users/actions'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { handleScrollIntoView } from 'utils/ScrollToView'
import SuccessMessage from 'utils/SuccessMessage'
import { validateNumber } from 'utils/decimalValidation'
import { downloadAttachment } from 'utils/downloadAttachment'
import { permittedEventCruds } from 'utils/permissionsValidation'

import {
  downloadSampleFile,
  uploadResultStatusUpdate,
} from 'modules/Drives/actions'
import { useParams } from 'react-router-dom'
import ConfirmDrawer from './ConfirmDrawer'

const RadioOptions = [
  {
    id: 1,
    label: 'Test Gorilla',
    value: 'TEST_GORILLA',
  },
  {
    id: 2,
    label: 'eSkill',
    value: 'E_SKILL',
  },
]
const DriveRole = [
  {
    id: 1,
    label: 'Internal',
    value: 'INTERNAL',
  },
  {
    id: 2,
    label: 'External',
    value: 'EXTERNAL',
  },
]

const UploadResult = ({
  uploadResult,
  setUploadResult,
  driveRoleList = [],
  selectedRoleId,
  setSelectedRoleId,
  roundList,
  noNeedRole,
  downloadCandidateList,
  driveId,
  roleId,
  uploadResultAPI,
  setIsDrawer,
  getCandidateList,
  getGDList,
  getRoleMetrics,
  upload,
  setUpload,
  fileUpload,
  externalAssessment = false,
  stage,
  checkType,
  assessment,
  rolesMetrics,
  setSearchParams,
  searchParams,
}) => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const params = useParams()
  const [selectedRound, setSelectedRound] = useState('')
  const [interviewType, setInterviewType] = useState('')
  const [fileURL, setFileURL] = useState('')
  const [file, setFile] = useState('')
  const [errorMessage, setErrorMessage] = useState([])
  const [otherError, setOtherError] = useState('')
  const [isSubmit, setIsSubmit] = useState(false)
  const [isFileLoader, setIsFileLoader] = useState(false)
  const [isLoader, setIsLoader] = useState(false)
  const permission = useSelector(state => state?.auth?.permissions)
  const [scheduleTemplate, setScheduleTemplate] = useState(null)
  const [onHoldTemplate, setOnHoldTemplate] = useState(null)
  const [rejectTemplate, setRejectTemplate] = useState(null)
  const [external, setExternal] = useState(false)
  const [confirmDrawer, setConfirmDrawer] = useState(false)
  const [fileName, setFileName] = useState('')
  const [keysList, setKeysList] = useState([
    {
      key: '',
      qp: '',
    },
  ])
  const permittedEvents = permittedEventCruds(
    permission,
    'Evaluation Process - Fresher'
  )
  const Schedule =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''
  useEffect(() => {
    if (stage != 'all_candidates') {
      setSelectedRound(stage)
      form.setFieldsValue({
        interviewRound: stage,
      })
    }
  }, [stage])
  useEffect(() => {
    if (checkType) setInterviewType(checkType)
  }, [checkType])
  useEffect(() => {
    ;(async () => {
      if (Schedule?.id) {
        let responce = await dispatch(getNotificationCatalogues(Schedule?.id))
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Student Shortlisted' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setScheduleTemplate(filteredArray[0].eventNotificationTemplate)
        }

        const filteredArray1 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName === 'Student OnHold' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray1?.length > 0) {
          setOnHoldTemplate(filteredArray1[0].eventNotificationTemplate)
        }
        const filteredArray2 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Student rejection' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray2?.length > 0) {
          setRejectTemplate(filteredArray2[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Schedule])
  const addToForm = () => {
    setKeysList([
      ...keysList,
      {
        key: '',
        qp: '',
      },
    ])
  }

  const onDelete = name => {
    setKeysList(keysList?.filter((data, index) => index !== name))
  }
  function isObject(value) {
    return typeof value === 'object' && value !== null
  }
  const onClickField = (value, index, type) => {
    let feedback = keysList.map((data, indx) => {
      if (index === indx) {
        return {
          ...data,
          [type]: value,
        }
      } else {
        return data
      }
    })
    setKeysList(feedback)

    form.setFieldsValue({
      feedback: feedback,
    })
  }

  const resetForm = () => {
    form.resetFields()
    setSelectedRoleId(driveRoleList[0]?.roleId)
    setSelectedRound('')
    setInterviewType('')
    setKeysList([
      {
        key: '',
        qp: '',
      },
    ])
    setFile('')
    setErrorMessage([])
    setFileURL('')
    setOtherError('')
  }

  const handleUpload = async () => {
    setIsLoader(true)
    let payload = {
      interviewRound: stage,
      excelFileLink: fileURL,
    }

    let response
    if (interviewType === 'ASSESMENT') {
      response = await dispatch(
        uploadResultAPI(driveId, roleId || selectedRoleId, payload)
      )
    } else {
      response = await dispatch(
        uploadResultStatusUpdate(driveId, roleId || selectedRoleId, payload)
      )
    }

    if (response?.status >= 200 && response?.status <= 300) {
      const shortlist = []
      const hold = []
      const rejected = []
      const successRecords = response?.data?.data?.sucessRecords || []
      for (const student of successRecords) {
        const status = student['Status']
        if (status === 'SHORTLISTED') {
          shortlist.push(student)
        } else if (status === 'HOLD') {
          hold.push(student)
        } else if (status === 'REJECTED') {
          rejected.push(student)
        }
      }

      if (scheduleTemplate && shortlist) {
        const final = shortlist?.map(item => {
          const template = scheduleTemplate?.templateText
          return {
            to: item?.Email,
            subject: scheduleTemplate?.subject,
            htmlBody: template,
          }
        })
        dispatch(sendNotificationBulkEmail(final))
      }
      if (onHoldTemplate && hold) {
        const currentDate = moment().format('DD MMM YYYY')
        const final = hold?.map(item => {
          const template = onHoldTemplate?.templateText
            .replace('{roleName}', driveRoleList[0]?.roleName)
            .replace('{date}', currentDate)
          return {
            to: item?.Email,
            subject: onHoldTemplate?.subject,
            htmlBody: template,
          }
        })
        dispatch(sendNotificationBulkEmail(final))
      }
      if (rejectTemplate && rejected) {
        const currentDate = moment().format('DD MMM YYYY')
        const final = rejected?.map(item => {
          const template = rejectTemplate?.templateText
            .replace('{roleName}', driveRoleList[0]?.roleName)
            .replace('{date}', currentDate)
          return {
            to: item?.Email,
            subject: rejectTemplate?.subject,
            htmlBody: template,
          }
        })
        dispatch(sendNotificationBulkEmail(final))
      }
      setIsLoader(false)
      SuccessMessage('File uploaded successfully!')
      setUpload(true)
      resetForm()
      if (getCandidateList) {
        getCandidateList()
      }
      if (getGDList) getGDList()
      dispatch(getRoleMetrics(driveId, roleId || selectedRoleId))
    } else {
      setIsLoader(false)
      handleScrollIntoView('error', 'center')
      if (getCandidateList) {
        getCandidateList()
      }
      if (response?.response?.data?.message === 'Failed') {
        setErrorMessage(response?.response?.data?.data?.failedRecords)
      } else {
        setOtherError(response?.response?.data?.message)
      }
    }
  }

  const onDownload = async keys => {
    let keysData =
      interviewType !== 'ASSESMENT'
        ? keys?.map(key => {
            return { key: key, qp: 0 }
          })
        : keysList

    let payload = {
      interviewType: interviewType,
      keys: keysData,
      stage: selectedRound,
    }

    let response

    if (interviewType === 'ASSESMENT') {
      response = await dispatch(
        downloadCandidateList(
          driveId,
          roleId || selectedRoleId,
          selectedRound,
          payload
        )
      )
    } else {
      response = await dispatch(
        downloadSampleFile(driveId, roleId || selectedRoleId, payload)
      )
    }

    if (response.status >= 200 && response?.status <= 300) {
      downloadAttachment(response?.data?.data?.url)
      SuccessMessage('File downloaded successfully!')
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }

  const onChangeFileUpload = async info => {
    setIsFileLoader(true)
    if (info?.file?.status === 'done') {
      setFile(info?.file)
      let response = await dispatch(
        uploadFile(info?.file?.originFileObj, info?.file?.name)
      )
      if (response) {
        setFileURL(response)
        setIsFileLoader(false)
        setErrorMessage([])
        setOtherError('')
      }
    }
  }

  const onFinish = async value => {
    if (isSubmit) {
      onDownload(value?.keys)
      setIsSubmit(false)
    }

    if (checkType !== 'EXTERNAL_ASSESMENT') {
      if (fileURL) {
        handleUpload()
      } else {
        if(fileURL.length)
        ErrorMessage('Please upload the file!')
      }
    }

    if (checkType === 'EXTERNAL_ASSESMENT') {
      if (fileURL) {
        setIsLoader(true)
        let response = await fileUpload(
          params?.roleId,
          driveId,
          file,
          checkType,
          stage
        )

        if (response?.status >= 200 && response?.status <= 300) {
          SuccessMessage('File uploaded successfully!')
          setFileName(response?.data?.data?.savedFiles?.[0])
          setConfirmDrawer(true)
          setUploadResult(false)
          setIsLoader(false)
          resetForm()
          let dataObject = rolesMetrics
          const metrics = await dispatch(
            getRoleMetrics(driveId, roleId || selectedRoleId)
          )
          if (metrics?.data?.message === 'Success') {
            const stage = searchParams.get('stage')
            const selectedMetrics = metrics?.data?.data?.[0]?.rounds?.find(
              item => item.roundName === stage
            )
            dataObject = selectedMetrics
          }

          setSearchParams({
            ...searchParams,
            isUpload: isObject(dataObject?.extAssmnts),
            stage: dataObject?.roundName,
            type: dataObject?.type ? rolesMetrics?.type : 'all',
            assessment: dataObject?.assesmentType
              ? dataObject?.assesmentType
              : 'Test Gorilla',
            assessmentId: dataObject?.extAssmnts?.id,
          })
          if (getCandidateList) {
            getCandidateList()
          }
        } else {
          if (getCandidateList) {
            getCandidateList()
          }

          setIsLoader(false)
          ErrorMessage(response?.response?.data?.message)
        }
      } else {
        ErrorMessage('Please upload the file!')
      }
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      feedback: keysList,
    })
  }, [keysList])

  useEffect(() => {
    form.setFieldsValue({
      role: selectedRoleId,
    })
  }, [selectedRoleId])

  const onChangeRadio = e => {
    if (e.target.value == 'EXTERNAL') {
      setExternal(true)
    } else {
      setExternal(false)
    }
  }
  const content = () => {
    return (
      <>
        {!upload && (
          <Form
            id={'uploadForm'}
            form={form}
            onFinish={onFinish}
            initialValues={{
              feedback: keysList,
            }}
          >
            <Wrapper>
              {checkType === 'EXTERNAL_ASSESMENT' ? (
                <>
                  <FormItem marginbottom={'30px'} name={'role'}>
                    <Label>Select Role </Label>
                    <Select
                      value={driveRoleList?.[0]?.roleName}
                      showSearch={true}
                      OptionData={[{ roundName: driveRoleList?.[0]?.roleName }]}
                      filterOption={false}
                      valueParam="roundName"
                      nameParam="roundName"
                      placeholder="Eg. Technical"
                      id={'upload_round'}
                      disabled
                    />
                  </FormItem>
                  <FormItem marginbottom={'30px'} name={'interviewRound'}>
                    <Label>Select Round </Label>
                    <Select
                      value={'External Assessment'}
                      showSearch={true}
                      OptionData={[{ roundName: 'External Assessment' }]}
                      filterOption={false}
                      valueParam="roundName"
                      nameParam="roundName"
                      placeholder="Eg. Technical"
                      id={'upload_round'}
                      disabled
                    />
                  </FormItem>

                  <Label>Assessment Type</Label>
                  <RadioGroup
                    spaceBetween
                    width="40%"
                    onChange={onChangeRadio}
                    value={'EXTERNAL'}
                    onChangeValue={external}
                  >
                    {DriveRole?.map((item, index) => (
                      <Radio
                        key={index + item?.value}
                        border={true}
                        label={item?.label}
                        value={item?.value}
                        width={'100%'}
                        disable={true}
                      />
                    ))}
                  </RadioGroup>
                  <br />

                  <>
                    <Label>External Assessment Type</Label>
                    <Select
                      showSearch={true}
                      OptionData={RadioOptions}
                      filterOption={true}
                      valueParam="value"
                      value={
                        assessment === 'TEST_GORILA'
                          ? 'Test Gorilla'
                          : assessment || assessment === 'E_SKILL'
                          ? 'eSkill'
                          : assessment
                      }
                      nameParam="label"

                      placeholder="Select Assessment Type"
                      id={'upload_round'}
                      width="40%"
                      disabled={true}
                    />

                    <br />
                  </>
                  <Fragment>
                    {isFileLoader && (
                      <SpinStyle centerVertically center>
                        <Spin />
                      </SpinStyle>
                    )}
                    <StyledUpload
                      multiple={false}
                      type="file"
                      accept={assessment === 'TEST_GORILA' ? '.xlsx' : '.csv'}
                      customRequest={dummyRequest}
                      onChange={onChangeFileUpload}
                      itemRender={(_, file) => {}}
                    >
                      <UploadFlex column alignCenter>
                        <UploadIconDiv>
                          <UploadIcon />
                        </UploadIconDiv>
                        <UploadFileDiv>
                          Browse for file or Drag and drop
                        </UploadFileDiv>
                        <FileNameDiv>
                          Format (
                          {assessment === 'TEST_GORILA' ? '.xlsx' : '.csv'})
                        </FileNameDiv>
                      </UploadFlex>
                    </StyledUpload>
                    {fileURL && (
                      <FileReader
                        file={file}
                        setFile={setFile}
                        fileURL={fileURL}
                        setFileURL={setFileURL}
                        setErrorMessage={setErrorMessage}
                      />
                    )}
                  </Fragment>
                  {errorMessage?.length > 0 && (
                    <Fragment>
                      <Divider />
                      <HeadTextWrap>Summary</HeadTextWrap>
                      <ErrorWrap>
                        <CrossFillIcon />
                        <SubText>Issue with the uploaded document</SubText>
                      </ErrorWrap>
                      <ErrorWrap id={'error'}>
                        <Flex column>
                          <Flex>
                            <WarningIcon />
                            <Wrap>
                              <SubText margin>Fix the following issues</SubText>
                            </Wrap>
                          </Flex>
                          {errorMessage?.map((data, kIndex) => {
                            return (
                              <Wrap column key={data?.['First Name'] + kIndex}>
                                <ListItem>
                                  {data?.['First Name']} {data?.['Last Name']}{' '}
                                  {data?.error}
                                </ListItem>
                              </Wrap>
                            )
                          })}
                        </Flex>
                      </ErrorWrap>
                    </Fragment>
                  )}
                  {otherError && (
                    <ErrorWrap>
                      <CrossFillIcon />
                      <SubText>{otherError}</SubText>
                    </ErrorWrap>
                  )}
                </>
              ) : (
                <>
                  {!noNeedRole && (
                    <FormItem
                      marginbottom={'30px'}
                      name={'role'}
                      rules={[
                        {
                          required: true,
                          message: 'Please select the role!',
                        },
                      ]}
                    >
                      <Label>Choose Role</Label>
                      <Select
                        value={selectedRoleId}
                        showSearch={true}
                        OptionData={driveRoleList}
                        filterOption={false}
                        valueParam="roleId"
                        right
                        nameParam="roleName"
                        placeholder="Eg. Software Engineer"
                        onChange={value => {
                          setSelectedRoleId(value)
                          form.setFieldsValue({
                            role: value,
                          })
                        }}
                        id={'upload_role'}
                      />
                    </FormItem>
                  )}
                  <FormItem
                    marginbottom={'30px'}
                    name={'interviewRound'}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: 'Please select the interview round!',
                    //   },
                    // ]}
                  >
                    <Label>Choose Interview Round </Label>
                    <Select
                      value={stage}
                      disabled={true}
                      showSearch={false}
                      OptionData={roundList[0]?.rounds
                        .slice(0, roundList[0]?.rounds?.length - 1)
                        .filter(round => round.count > 0)}
                      filterOption={false}
                      valueParam="roundName"
                      nameParam="roundName"
                      placeholder="Eg. Technical"
                      onChange={(value, Option) => {
                        setInterviewType(Option?.option?.type)
                        setSelectedRound(value)
                        form.setFieldsValue({
                          interviewRound: value,
                        })
                      }}
                      id={'upload_round'}
                    />
                  </FormItem>
                  {interviewType === 'ASSESMENT' && (
                    <Form.List name="feedback">
                      {(fields, { add, remove }) => {
                        return (
                          <>
                            <RemarksDiv isMargin>Key Parameters</RemarksDiv>
                            {fields.map(({ key, name }) => (
                              <Fragment key={name + key}>
                                <ScoreFlex centerVertically spaceBetween>
                                  <FormItem
                                    name={[name, 'key']}
                                    rules={[
                                      {
                                        required: isSubmit,
                                        message: 'Please enter Key Parameters!',
                                      },
                                    ]}
                                    ismargin
                                  >
                                    <RemarksDiv isMargin>
                                      Label - {name + 1}
                                    </RemarksDiv>
                                    <Input
                                      width="100%"
                                      placeholder="Label"
                                      onChange={e =>
                                        onClickField(
                                          e.target.value,
                                          name,
                                          'key'
                                        )
                                      }
                                      value={keysList[name]?.key}
                                    />
                                  </FormItem>
                                  <FormItem
                                    name={[name, 'qp']}
                                    rules={[
                                      {
                                        required: isSubmit,
                                        message:
                                          'Please enter qualifying score!',
                                      },
                                      {
                                        validator: (_, value) => {
                                          let isValid = validateNumber(value)
                                          if (!isValid) {
                                            return Promise.reject(
                                              new Error('Not Valid')
                                            )
                                          }
                                          return Promise.resolve()
                                        },
                                      },
                                    ]}
                                    ismargin
                                  >
                                    <RemarksDiv isMargin>
                                      Qualifying score
                                    </RemarksDiv>
                                    <Input
                                      width="100%"
                                      placeholder="Qualifying score"
                                      onChange={e =>
                                        onClickField(e.target.value, name, 'qp')
                                      }
                                      value={keysList[name]?.qp}
                                      suffix={'%'}
                                      type={'number'}
                                    />
                                  </FormItem>

                                  <IconWrapper
                                    center
                                    onClick={() => {
                                      remove(name)
                                      onDelete(name)
                                    }}
                                    disable={keysList?.length === 1}
                                  >
                                    <DeleteIcon />
                                  </IconWrapper>
                                </ScoreFlex>

                                <Wrapper />
                              </Fragment>
                            ))}
                            <FlexWrapper />
                            <Form.Item>
                              <Button.Secondary
                                text={'Add More field'}
                                width="100%"
                                icon={<PlusWhiteIcon />}
                                dashed="true"
                                onClick={() => {
                                  add()
                                  addToForm()
                                }}
                              />
                            </Form.Item>
                          </>
                        )
                      }}
                    </Form.List>
                  )}

                  <CandiadateFlex spaceBetween row centerVertically>
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <DownLoadIcon />
                      <DocFlex column>
                        <CandidateInfo>Candidate Sample Doc</CandidateInfo>
                        <TemolateDiv>
                          To upload bulk upload data, use template
                        </TemolateDiv>
                      </DocFlex>
                    </div>
                    <Button.Secondary
                      width="144px"
                      height="32px"
                      text="Download Sample"
                      htmlType={'submit'}
                      form={'uploadForm'}
                      onClick={() => setIsSubmit(true)}
                    />
                  </CandiadateFlex>
                  <Fragment>
                    {isFileLoader && (
                      <SpinStyle centerVertically center>
                        <Spin />
                      </SpinStyle>
                    )}
                    <StyledUpload
                      multiple={false}
                      type="file"
                      accept={'.xlsx'}
                      customRequest={dummyRequest}
                      onChange={onChangeFileUpload}
                      itemRender={(_, file) => {}}
                    >
                      <UploadFlex column alignCenter>
                        <UploadIconDiv>
                          <UploadIcon />
                        </UploadIconDiv>
                        <UploadFileDiv>
                          Browse for file or Drag and drop
                        </UploadFileDiv>
                        <FileNameDiv>Formet (.xlsx)</FileNameDiv>
                      </UploadFlex>
                    </StyledUpload>
                    {fileURL && (
                      <FileReader
                        file={file}
                        setFile={setFile}
                        fileURL={fileURL}
                        setFileURL={setFileURL}
                        setErrorMessage={setErrorMessage}
                      />
                    )}
                  </Fragment>
                  {errorMessage?.length > 0 && (
                    <Fragment>
                      <Divider />
                      <HeadTextWrap>Summary</HeadTextWrap>
                      <ErrorWrap>
                        <CrossFillIcon />
                        <SubText>Issue with the uploaded document</SubText>
                      </ErrorWrap>
                      <ErrorWrap id={'error'}>
                        <Flex column>
                          <Flex>
                            <WarningIcon />
                            <Wrap>
                              <SubText margin>Fix the following issues</SubText>
                            </Wrap>
                          </Flex>
                          {errorMessage?.map((data, kIndex) => {
                            return (
                              <Wrap column key={data?.['First Name'] + kIndex}>
                                <ListItem>
                                  {data?.['First Name']} {data?.['Last Name']}{' '}
                                  {data?.error}
                                </ListItem>
                              </Wrap>
                            )
                          })}
                        </Flex>
                      </ErrorWrap>
                    </Fragment>
                  )}
                  {otherError && (
                    <ErrorWrap>
                      <CrossFillIcon />
                      <SubText>{otherError}</SubText>
                    </ErrorWrap>
                  )}
                </>
              )}
            </Wrapper>
          </Form>
        )}
        {upload && (
          <UploadMsgFlex column center centerVertically>
            <ResultIconDiv>
              <UploadResultIcon />
            </ResultIconDiv>
            <ResultDiv>Result Updated Successfully</ResultDiv>
            <FileInfoDiv>
              <FileTextSpan>file has been successfully updated</FileTextSpan>
            </FileInfoDiv>
            <ButtonDiv>
              <Button.Secondary
                text="Close"
                width="80px"
                onClick={() => {
                  setUploadResult(false)
                  setIsDrawer(false)
                }}
              />
            </ButtonDiv>
          </UploadMsgFlex>
        )}
      </>
    )
  }
  const footer = () => {
    return (
      <>
        {!upload && (
          <FooterFlex flexEnd>
            <Button.Secondary
              width="88px"
              text="Cancel"
              onClick={() => {
                resetForm()
                setUploadResult(false)
                setIsDrawer(false)
              }}
            />
            <Button.Primary
              width="90px"
              text="Upload"
              htmlType="submit"
              form={'uploadForm'}
              onClick={() => setIsSubmit(false)}
              loading={isLoader}
            />
          </FooterFlex>
        )}
      </>
    )
  }
  return (
    <>
      <Drawer
        width="43%"
        title={'Upload File'}
        placement="right"
        padding="0px 30px 30px 30px"
        visible={uploadResult}
        content={content()}
        footer={footer()}
        onClose={() => {
          resetForm()
          setUploadResult(false)
          setUpload(false)
        }}
        closable
      />
      <ConfirmDrawer
        confirmDrawer={confirmDrawer}
        setConfirmDrawer={setConfirmDrawer}
        file={fileName}
        rolesMetrics={rolesMetrics}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
      />
    </>
  )
}

export default UploadResult
